angular.module('admin.categories', [
  'admin.categories.index',
  'admin.categories.tree',
  'admin.categories.detail'
]);


// WEBPACK FOOTER //
// ./client/src/app/admin/categories/index.js